import {
  AgoraRTCProvider,
  useRTCClient
} from "agora-rtc-react";
import AgoraRTC from "agora-rtc-sdk-ng";
import AuthenticationWorkflowManager from "./authenticationWorkflowManager.jsx";
import config from "./config";
import { Box, IconButton, Modal } from "@mui/material";
import Draggable from "react-draggable";
import { useState, useMemo, useEffect, useRef } from "react";

export default function AuthenticationWorkflow(props) {
  console.log("AuthenticationWorkflow props: ", props);

  // Use callId from props, generate fallback if not provided
  const callId = useMemo(() => 
    props.callId || Date.now(), 
    [props.callId]
  );

  const prevCallIdRef = useRef(callId);
  const prevClientRef = useRef(null);

  // Create client with callId as dependency to force recreation on new call
  const agoraEngine = useMemo(() => {
    console.log("Creating new Agora client for call:", callId);
    
    // Clean up previous client if it exists
    if (prevClientRef.current && prevCallIdRef.current !== callId) {
      console.log("Cleaning up previous Agora client");
      try {
        prevClientRef.current.leave().catch(err => console.warn("Previous client leave error:", err));
        prevClientRef.current.removeAllListeners();
      } catch (err) {
        console.warn("Error cleaning up previous client:", err);
      }
    }
    
    const newClient = AgoraRTC.createClient({ codec: "vp8", mode: config.selectedProduct });
    prevClientRef.current = newClient;
    return newClient;
  }, [callId]);

  // Clean up when component unmounts or callId changes
  useEffect(() => {
    return () => {
      if (agoraEngine) {
        console.log("Component unmounting, cleaning up Agora client");
        try {
          agoraEngine.leave().catch(err => console.warn("Cleanup leave error:", err));
          agoraEngine.removeAllListeners();
        } catch (err) {
          console.warn("Error during component cleanup:", err);
        }
      }
    };
  }, [agoraEngine]);

  // Track callId changes
  useEffect(() => {
    if (prevCallIdRef.current !== callId && prevCallIdRef.current !== null) {
      console.log("CallId changed from", prevCallIdRef.current, "to", callId);
    }
    prevCallIdRef.current = callId;
  }, [callId]);

  return (
    <div>
      <AgoraRTCProvider client={agoraEngine} key={callId}>
        <AuthenticationWorkflowManager client={agoraEngine} callId={callId} {...props} />
      </AgoraRTCProvider>
    </div>
  );
}
